/**
 * @generated SignedSource<<f4a67892eb7db7c1b5290a6aeebc1462>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uuid"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      },
      {
        "kind": "Variable",
        "name": "uuid",
        "variableName": "uuid"
      }
    ],
    "concreteType": "Property",
    "kind": "LinkedField",
    "name": "propertySettingsUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalIdentifier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TimeRange",
        "kind": "LinkedField",
        "name": "active",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "start",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "finish",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PropertySettingsUpdateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PropertySettingsUpdateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "8e32c2bafef975f6dd0916d847b5f8f1",
    "id": null,
    "metadata": {},
    "name": "PropertySettingsUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation PropertySettingsUpdateMutation(\n  $uuid: ID!\n  $input: PropertySettingsUpdateInput!\n) {\n  propertySettingsUpdate(uuid: $uuid, input: $input) {\n    id\n    uuid\n    externalIdentifier\n    title\n    active {\n      start\n      finish\n    }\n    createdAt\n    updatedAt\n  }\n}\n"
  }
};
})();

node.hash = "03998fedd4d99fe1ca5656f2f565177e";

export default node;
